interface clearButtonProps {
  title?: string;
  className?: string;
  dataTestId?: string;
  onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  text?: string;
  theme?: "blue" | "orange";
}

export const ClearButton = ({ theme = "blue", ...props }: clearButtonProps) => {
  const themeClasses = {
    blue: "tw-bg-blue-2 hover:tw-bg-blue-0",
    orange: "tw-bg-orange-1 hover:tw-bg-orange-0",
  };

  return (
    <div title={props.title}>
      <button
        className={`tw-h-[24px] tw-rounded-[4px] tw-border-none tw-align-top tw-text-white ${themeClasses[theme]} ${props.className}`}
        data-testid={props.dataTestId}
        onClick={props.onClick}
      >
        <div className="tw-text-[14px] tw-font-normal">
          {props.text || "Clear"}
        </div>
      </button>
    </div>
  );
};
